const actions = {
	GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER: 'GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER',
	GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS: 'GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS',

	CREATE_NEW_QUESTION_MULTIPLE_CHOICE_MULTIPLE_ANSWER: 'CREATE_NEW_QUESTION_MULTIPLE_CHOICE_MULTIPLE_ANSWER',
	CREATE_NEW_QUESTION_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS: 'CREATE_NEW_QUESTION_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS',

	DELETE_MULTIPLE_CHOICE_MULTIPLE_ANSWER: 'DELETE_MULTIPLE_CHOICE_MULTIPLE_ANSWER',
	DELETE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS: 'DELETE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS',

	GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL: 'GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL',
	GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL_SUCCESS: 'GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL_SUCCESS',

	UPDATE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL: 'UPDATE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL',
	UPDATE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL_SUCCESS: 'UPDATE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getMultipleChoiceMultipleAnswer: (model) => ({
		type: actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER,
		payload: { model },
	}),

	createQuesMultipleChoiceMultipleAnswer: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_MULTIPLE_CHOICE_MULTIPLE_ANSWER,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getMultipleChoiceMultipleAnswerDetail: (id, cbSuccess, cbError) => ({
		type: actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL,
		payload: { id },
		cbSuccess,
		cbError
	}),

	updateMultipleChoiceMultipleAnswerDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteMultipleChoiceMultipleAnswer: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_MULTIPLE_CHOICE_MULTIPLE_ANSWER,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
